export const APIStatus = {
  idle: 'idle',
  loading: 'loading',
  loaded: 'loaded',
  failed: 'failed',
  closeSession: 'closeSession'
}; 
